import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
  User,
} from "feather-icons-react/build/IconComponents";
import {
  Upload,
  Button,
  Spin,
  notification,
  DatePicker,
  Table,
  Typography,
  Select,
} from "antd";
import React, { useEffect, useState, useContext } from "react";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../../core/redux/action";
import {
  CloseOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { getUserById, updateUser } from "../../../service/userService";
import Swal from "sweetalert2";
import { UserContext } from "../../../context/userContext";
import { getEmployeeByUserId } from "../../../service/employeeService";
import moment from "moment/moment";
import { base_path_img } from "../../../environment";
import { Info } from "react-feather";
import {
  getAllDepartments,
  getAllDesignations,
  getAllShiftsMethod,
} from "../../../service/ApiServices";

const { Text } = Typography;

const GeneralSettings = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [formData, setFormData] = useState({ gender: "" });
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [empData, setEmpData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [userDetail, setUserDetail] = useState(null);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const { setUser } = useContext(UserContext);
  const [, setLoading3] = useState(false);
  const [, setLoading2] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [documents, setDocuments] = useState([]);

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const userObj = userData?.data;

  useEffect(() => {
    console.log("Use Effect 01");
    if (userObj && userObj._id) {
      setUserId(userObj._id);

      const fetchUserData = async () => {
        try {
          const data = await getUserById(userObj._id);
          setUserDetail(data.data);
          setEmail(data.data.email || "");
          setPhoneNumber(data.data.phone || "");

          const fullName = data.data.name
            ? data.data.name.split(" ")
            : ["", ""];
          setFirstName(fullName[0]);
          setLastName(fullName.slice(1).join(" "));
          console.log(
            "Fetched userDetail.gender (not used):",
            data.data.gender
          );
        } catch (err) {
          console.error("Error fetching user:", err);
        }
      };
      fetchUserData();

      getEmployeeByUserId(userObj._id)
        .then((value) => {
          console.log("Get Employee", value);
          if (value.status === 200) {
            console.log("Get Employee value.data.data", value.data.data);
            setEmpData(value.data.data);
            const normalizedGender =
              value.data.data.gender?.toLowerCase() || "";
            console.log("Normalized gender from empData:", normalizedGender);
            setFormData({
              ...value.data.data,
              date_of_birth: value.data.data.date_of_birth
                ? moment(value.data.data.date_of_birth)
                : null,
              gender: ["male", "female", "other", ""].includes(normalizedGender)
                ? normalizedGender
                : "",

              marital_status: value.data.data.marital_status || "Single",
              emergency_name: value.data.data.emergency_name || "",
              emergency_relationship: value.data.data.emergency_relationship || "",
              emergency_no_1: value.data.data.emergency_no_1 || "",
              emergency_no_2: value.data.data.emergency_no_2 || "",
              address: value.data.data.address || "",
              residenceAddress: value.data.data.residenceAddress || "",
            });
            const docs = value.data.data.relevantDocs || [];
            setDocuments(
              docs.map((doc, index) => ({
                key: index.toString(),
                name: doc.split("/").pop(),
                url: doc,
                status: "done",
              }))
            );
          }
        })
        .catch((reason) => {
          notification.error({
            message: `Something went wrong`,
            description: reason,
            placement: "top",
          });
        });
    }
  }, []);

  useEffect(() => {
    getAllShiftsMethod({ setShiftData: setShifts });
    getAllDesignations({
      search: "",
      setData: setDesignations,
      setLoading: setLoading2,
    });
    getAllDepartments({
      search: "",
      setData: setDepartments,
      setLoading: setLoading3,
    });
    if (empData) {
      console.log("Emp Data", empData);
      const normalizedGender = empData.gender?.toLowerCase() || "";
      console.log("Normalized gender from empData:", normalizedGender);
      setFormData({
        ...empData,
        date_of_birth: empData.date_of_birth
          ? moment(empData.date_of_birth)
          : null,
        gender: ["male", "female", "other", ""].includes(normalizedGender)
          ? normalizedGender
          : "",
      });
      setSelectedImage(
        empData?.profile_image_url
          ? `${base_path_img}${empData.profile_image_url}`
          : null
      );
    }
  }, [empData]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    }
  };

  const handleImageClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (email && !validateEmail(email)) {
      notification.error({
        message: "Invalid Email",
        description: "Please enter a valid email address.",
        placement: "topRight",
      });
      return;
    }
    
    setLoading(true);

    const user = userData?.data;

    const formDataToSend = new FormData();
    formDataToSend.append("name", `${firstName} ${lastName}`.trim());

    formDataToSend.append("phone", phoneNumber);
    formDataToSend.append("email", email);



    if (formData.date_of_birth) {
      formDataToSend.append(
        "date_of_birth",
        formData.date_of_birth.format("YYYY-MM-DD")
      );
    }
    if (formData.emergency_name) {
      formDataToSend.append("emergency_name", formData.emergency_name);
    } if (formData.emergency_relationship) {
      formDataToSend.append("emergency_relationship", formData.emergency_relationship);
    }

    if (formData.emergency_no_1) {
      formDataToSend.append("emergency_no_1", formData.emergency_no_1);
    } if (formData.emergency_no_2) {
      formDataToSend.append("emergency_no_2", formData.emergency_no_2);
    }
    if (formData.address) {
      formDataToSend.append("address", formData.address);
    } if (formData.residenceAddress) {
      formDataToSend.append("residenceAddress", formData.residenceAddress);
    }





    if (["male", "female", "other"].includes(formData.gender)) {
      console.log("Appending gender to FormData:", formData.gender);
      formDataToSend.append("gender", formData.gender);
    } else {
      console.log("Skipping gender (invalid or empty):", formData.gender);
    }
    if (["Single", "Married"].includes(formData.marital_status)) {
      console.log(
        "Appending marital_status to FormData:",
        formData.marital_status
      );
      formDataToSend.append("marital_status", formData.marital_status);
    }
    if (selectedImage && selectedImage instanceof File) {
      formDataToSend.append("profilePicture", selectedImage);
    }
    documents.forEach((doc, index) => {
      if (doc.originFileObj) {
        formDataToSend.append(`relevantDocs[${index}]`, doc.originFileObj);
      } else {
        formDataToSend.append(`existingDocs[${index}]`, doc.url);
      }
    });

    try {
      const updatedData = await updateUser(userId, formDataToSend);
      const userData = await getUserById(userId);
      console.log("Updated user data:", userData);

      // Update UserContext with full user data, preserving permissions
      setUser({
        firstName: firstName,
        lastName: lastName,
        profile_pic: updatedData?.data.profile_picture,
        permissions: userData.data.permissions || user.permissions, // Preserve permissions
        role: userData.data.role || user.role, // Preserve role
      });

      setUserDetail(userData.data);
      const normalizedGender = userData.data.gender?.toLowerCase() || "";
      setFormData((prev) => ({
        ...prev,
        date_of_birth: userData.data.date_of_birth
          ? moment(userData.data.date_of_birth)
          : null,
        gender: ["male", "female", "other", ""].includes(normalizedGender)
          ? normalizedGender
          : "",
        marital_status: userData.data.marital_status || "Single",
        emergency_name: userData.data.emergency_name || "",
        emergency_relationship: userData.data.emergency_relationship || "",
        emergency_no_1: userData.data.emergency_no_1 || "",
        emergency_no_2: userData.data.emergency_no_2 || "",
        address: userData.data.address || "",
        residenceAddress: userData.data.residenceAddress || "",
      }));
      setEmail(userData.data.email || "");
      setPhoneNumber(userData.data.phone || "");
      notification.success({
        message: "Profile Updated",
        description:
          "Your profile and documents have been updated successfully.",
        placement: "topRight",
      });
    } catch (error) {
      console.error("Error updating user:", error);
      notification.error({
        message: "Update Failed",
        description: "There was an error updating your profile.",
        placement: "topRight",
      });
    }
    setLoading(false);
  };
  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will lose any unsaved changes!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, discard changes",
      cancelButtonText: "No, keep editing",
    }).then((result) => {
      if (result.isConfirmed) {
        const fetchUserData = async () => {
          try {
            const data = await getUserById(userObj._id);
            setUserDetail(data.data);
            setEmail(data.data.email || "");
            setPhoneNumber(data.data.phone || "");
            const fullName = data.data.name
              ? data.data.name.split(" ")
              : ["", ""];
            setFirstName(fullName[0]);
            setLastName(fullName.slice(1).join(" "));
          } catch (err) {
            console.error("Error fetching user:", err);
          }
        };
        fetchUserData();
        const normalizedGender = empData?.gender?.toLowerCase() || "";
        setFormData((prev) => ({
          ...prev,
          ...empData,
          date_of_birth: empData?.date_of_birth
            ? moment(empData.date_of_birth)
            : null,
          gender: ["male", "female", "other", ""].includes(normalizedGender)
            ? normalizedGender
            : "",
          marital_status: empData?.marital_status || "Single",
          emergency_name: empData?.emergency_name || "",
          emergency_relationship: empData?.emergency_relationship || "",
          emergencyNo1: empData?.emergencyNo1 || "",
          emergencyNo2: empData?.emergencyNo2 || "",
          address: empData?.address || "",
          residenceAddress: empData?.residenceAddress || "",
        }));
        setDocuments(
          empData?.relevantDocs?.map((doc, index) => ({
            key: index.toString(),
            name: doc.split("/").pop(),
            url: doc,
            status: "done",
          })) || []
        );
        setSelectedImage(
          empData?.profile_image_url
            ? `${base_path_img}${empData.profile_image_url}`
            : null
        );
        setImagePreview(null);
        Swal.fire(
          "Changes Discarded!",
          "Your unsaved changes have been discarded.",
          "success"
        );
      }
    });
  };
  const handlePreview = (file) => {
    window.open(file.url, "_blank");
  };

  const documentColumns = [
    {
      title: "File Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <a href={record.url} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <DeleteOutlined
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => {
            setDocuments((prev) =>
              prev.filter((doc) => doc.key !== record.key)
            );
          }}
        />
      ),
    },
  ];

  const employeeCategoryOptions = [
    { value: "Full Time", label: "Full Time" },
    { value: "Part Time", label: "Part Time" },
    { value: "Daily Basics", label: "Daily Basics" },
  ];

  const titleOptions = [
    { value: "Mr", label: "Mr." },
    { value: "Mrs", label: "Mrs." },
    { value: "Miss", label: "Miss." },
    { value: "Ms", label: "Ms." },
    { value: "Rev", label: "Rev." },
    { value: "Dr", label: "Dr." },
  ];

  const genderOptions = [
    { value: "", label: "Choose" },
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  const center = [
    { value: "OKI", label: "OKI" },
    { value: "OKIDS", label: "OKIDS" },
    { value: "OKIT", label: "OKIT" },
  ];

  const employeeTypes = [
    { value: "", label: "Choose" },
    { value: "Academic", label: "Academic" },
    { value: "Non Academic", label: "Non Academic" },
  ];

  const branchOptions = [
    { value: "wattala", label: "Wattala" },
    { value: "negombo", label: "Negombo" },
    { value: "kaduwela", label: "Kaduwela" },
    { value: "kiribathgoda", label: "Kiribathgoda" },
    { value: "kandana", label: "Kandana" },
    { value: "delgoda", label: "Delgoda" },
    { value: "lsu", label: "Wattala LSU" },
    { value: "cityschool", label: "City School - Negombo" }
  ];

  const payFrequencies = [
    { value: "", label: "Choose" },
    { value: "weekly", label: "Weekly" },
    { value: "biweekly", label: "Biweekly" },
    { value: "semimonthly", label: "Semi-Monthly" },
    { value: "monthly", label: "Monthly" },
    { value: "annually", label: "Annually" },
  ];

  const maritalStatusOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content settings-content">
          <div className="page-header settings-pg-header" style={{ display: "none" }}>
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Settings</h4>
                <h6>Manage your settings on portal</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="settings-wrapper d-flex">
                <div className="settings-page-wrap">
                  <form onSubmit={handleSubmit}>
                    <div className="setting-title">
                      <h4>Profile Settings</h4>
                    </div>
                    <div className="card-title-head">
                      <h6>
                        <span>
                          <User className="feather-chevron-up" />
                        </span>
                        User Information
                      </h6>
                    </div>
                    <div className="profile-pic-upload">
                      <div className="profile-pic">
                        {(selectedImage || empData?.profile_image_url) ? (
                          <img
                            src={imagePreview || selectedImage || (empData?.profile_image_url ? `${base_path_img}${empData.profile_image_url}` : "/placeholder.svg")}
                            alt="Profile"
                            style={{
                              width: "150px",
                              height: "118px",
                              borderRadius: "10%",
                              objectFit: "cover",
                            }}
                            onClick={handleImageClick}
                          />
                        ) : (
                          <span>
                            <PlusCircle className="plus-down-add" />
                            Profile Photo
                          </span>
                        )}
                      </div>
                      <div className="new-employee-field">
                        <div className="mb-0">
                          <div className="image-upload mb-0">
                            <input
                              type="file"
                              onChange={handleImageChange}
                              accept="image/*"
                            />
                            <div className="image-uploads">
                              <h4>Change Image</h4>
                            </div>
                          </div>
                          <span>
                            For better preview recommended size is 450px x
                            450px. Max size 5MB.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div className="card-title-head">
                        <h6>
                          <span>
                            <User className="feather-chevron-up" />
                          </span>
                          Personal Information
                        </h6>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Title</label>
                        <Select
                          value={
                            formData.title
                              ? titleOptions.find(
                                (option) => option.value === formData.title
                              )
                              : null
                          }
                          options={titleOptions}
                          className="select"
                          placeholder="Select Title"
                          isDisabled
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          id="fullName"
                          className="form-control"
                          value={formData.full_name}
                          disabled
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">NIC</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.nic || ""}
                          disabled
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Date of Birth</label>
                        <div className="input-groupicon calender-input">
                          <DatePicker
                            value={formData.date_of_birth}
                            onChange={(date) =>
                              setFormData({ ...formData, date_of_birth: date })
                            }
                            className="form-control"
                            placeholder="Select Date of Birth"
                            format="YYYY-MM-DD"
                            disabledDate={(current) =>
                              current && current > moment().endOf("day")
                            }
                            style={{ width: "100%", height: "38px" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Gender</label>
                        <Select
                          name="gender"
                          value={formData.gender || ""}
                          onChange={(value) => {
                            console.log("Selected gender value:", value);
                            setFormData((prev) => ({
                              ...prev,
                              gender: value,
                            }));
                          }}
                          className="select"
                          options={genderOptions}
                          placeholder="Choose"
                          optionFilterProp="value"
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Marital Status</label>
                        <Select
                          name="marital_status"
                          value={
                            formData.marital_status
                              ? maritalStatusOptions.find(
                                (option) =>
                                  option.value === formData.marital_status
                              )
                              : null
                          }
                          onChange={(value) => {
                            console.log("Selected :", value);
                            setFormData((prev) => ({
                              ...prev,
                              marital_status: value,
                            }));
                          }}
                          className="select"
                          options={maritalStatusOptions}
                          placeholder="Choose"
                        />
                      </div>
                      <div className="card-title-head" style={{
                        marginTop: "60px",
                      }}>
                        <h6>
                          <span>
                            <User className="feather-chevron-up" />
                          </span>
                          Contact Information
                        </h6>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={phoneNumber}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            setPhoneNumber(val);
                          }}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Permanent Address</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.address || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              address: e.target.value,
                            }))
                          }
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Residential Address</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.residenceAddress || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              residenceAddress: e.target.value,
                            }))
                          }
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="card-title-head" style={{
                        marginTop: "60px",
                      }}>
                        <h6>
                          <span>
                            <User className="feather-chevron-up" />
                          </span>
                          Employment Details
                        </h6>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">EPF Number</label>
                        <input
                          disabled
                          type="text"
                          className="form-control"
                          value={formData.epf_number || ""}
                          style={{ width: "100%", height: "40px" }}
                        />
                      </div>

                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Designation</label>
                        <div className="input-blocks">
                          <select
                            disabled
                            className="form-select"
                            value={formData.designation_id || "pending"}
                          >
                            <option value="pending">Choose</option>
                            {designations &&
                              designations.map((des, index) => (
                                <option key={index} value={des._id}>
                                  {des.designationName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Department</label>
                        <div className="input-blocks">
                          <select
                            disabled
                            className="form-select"
                            value={formData.department_id || "pending"}
                          >
                            <option value="pending">Choose</option>
                            {departments &&
                              departments.map((dep, index) => (
                                <option key={index} value={dep._id}>
                                  {dep.departmentName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Joining Date</label>
                        <div className="input-groupicon calender-input">
                          <DatePicker
                            value={
                              formData.joining_date
                                ? moment(formData.joining_date, "YYYY-MM-DD")
                                : null
                            }
                            className="form-control"
                            placeholder="Choose Date"
                            disabled
                            style={{ width: "100%", height: "38px" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Select Shift</label>
                        <Select
                          isDisabled
                          size="large"
                          showSearch
                          placeholder="Choose"
                          value={shifts.find(
                            (option) => option.value === formData.shift
                          )}
                          options={shifts}
                          style={{ width: "100%" }}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Branch</label>
                        <Select
                          value={
                            formData.branch === ""
                              ? null
                              : branchOptions.find((option) =>
                                formData.branch
                                  ?.toLowerCase()
                                  .includes(option.value?.toLowerCase())
                              )
                          }
                          options={branchOptions}
                          className="select"
                          placeholder="Select branch"
                          disabled
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Center</label>
                        <Select
                          value={
                            formData.center === ""
                              ? null
                              : center.find(
                                (option) => option.value === formData.center
                              )
                          }
                          options={center}
                          className="select"
                          disabled
                        />
                      </div>

                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Employee Type</label>
                        <Select
                          isDisabled
                          name="employee_type"
                          value={employeeTypes.find(
                            (option) => option.value === formData.employee_type
                          )}
                          className="select"
                          options={employeeTypes}
                          placeholder="Choose"
                          disabled
                        />
                      </div>


                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Employee Category</label>
                        <Select
                          value={
                            formData.employeeCategory
                              ? employeeCategoryOptions.find(
                                (option) =>
                                  option.value === formData.employeeCategory
                              )
                              : null
                          }
                          options={employeeCategoryOptions}
                          className="select"
                          placeholder="Select Employee Category"
                          disabled
                        />
                      </div>


                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Pay Frequency</label>
                        <Select
                          isDisabled
                          name="pay_frequency"
                          value={payFrequencies.find(
                            (option) => option.value === formData.pay_frequency
                          )}
                          className="select"
                          options={payFrequencies}
                          placeholder="Choose"
                          disabled
                        />
                      </div>
                      <div className="card-title-head" style={{
                        marginTop: "60px",
                      }}>
                        <h6>
                          <span>
                            <User className="feather-chevron-up" />
                          </span>
                          Emergency Contact Information
                        </h6>
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.emergency_name || ""}
                          onChange={(e) => {
                            const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                            setFormData((prev) => ({
                              ...prev,
                              emergency_name: val,
                            }));
                          }}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Relationship</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.emergency_relationship || ""}
                          onChange={(e) => {
                            const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                            setFormData((prev) => ({
                              ...prev,
                              emergency_relationship: val,
                            }));
                          }}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Emergency No 1</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.emergency_no_1 || ""}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            setFormData((prev) => ({
                              ...prev,
                              emergency_no_1: val,
                            }));
                          }}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-2">
                        <label className="form-label">Emergency No 2 (Optional)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.emergency_no_2 || ""}
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            setFormData((prev) => ({
                              ...prev,
                              emergency_no_2: val,
                            }));
                          }}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      {formData.employeeCategory === "Full Time" && (
                        <>
                          <div className="row" style={{ marginTop: "10px", display: "none" }}>
                            <div className="card-title-head">
                              <h6>
                                <span>
                                  <Info className="feather-edit" />
                                </span>
                                Compensation and Benefits
                              </h6>
                            </div>

                            <div
                              className="col-lg-3 col-md-2"
                              style={{ display: "none" }}
                            >
                              <label className="form-label">Basic Salary</label>
                              <input
                                disabled
                                type="number"
                                className="form-control"
                                value={formData.basic_salary || ""}
                                style={{ width: "100%", height: "40px" }}
                              />
                            </div>
                          </div>
                          <div className="row" style={{ marginTop: "60px", display: "none" }} >
                            <div className="card-title-head">
                              <h6>
                                <span>
                                  <Info className="feather-edit" />
                                </span>
                                Relevant Documents
                              </h6>
                            </div>
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <h6 style={{ marginBottom: "10px" }}>
                                  Existing Documents
                                </h6>
                                {documents.length > 0 ? (
                                  <Table
                                    columns={documentColumns}
                                    dataSource={documents}
                                    rowKey="key"
                                    pagination={false}
                                    style={{ marginBottom: "20px" }}
                                  />
                                ) : (
                                  <Text type="secondary">
                                    No documents uploaded yet.
                                  </Text>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Add New Documents (PDF only, max 5)
                                </label>
                                <Upload
                                  listType="text"
                                  fileList={[]}
                                  onChange={({ file, fileList }) => {
                                    if (
                                      documents.length + fileList.length >
                                      5
                                    ) {
                                      notification.warning({
                                        message: "Limit Exceeded",
                                        description:
                                          "You can only have a maximum of 5 documents!",
                                        placement: "top",
                                      });
                                      return;
                                    }
                                    const fileType = file.name
                                      ?.split(".")
                                      .pop()
                                      .toLowerCase();
                                    const isValidType = ["pdf"].includes(
                                      fileType
                                    );
                                    if (
                                      file.status !== "removed" &&
                                      !isValidType
                                    ) {
                                      notification.warning({
                                        message: "Invalid File Type",
                                        description:
                                          "You can only upload PDF files!",
                                        placement: "top",
                                      });
                                      return;
                                    }

                                    const newDocs = fileList.map((f, idx) => ({
                                      key: (documents.length + idx).toString(),
                                      name: f.name,
                                      url: f.originFileObj
                                        ? URL.createObjectURL(f.originFileObj)
                                        : undefined,
                                      status: "done",
                                      originFileObj: f.originFileObj,
                                    }));

                                    setDocuments([...documents, ...newDocs]);
                                  }}
                                  onPreview={handlePreview}
                                  beforeUpload={() => false}
                                  multiple={true}
                                >
                                  <Button
                                    className="btn-grid-upload"
                                    icon={
                                      <UploadOutlined className="upload-icon" />
                                    }
                                  >
                                    Upload New Document
                                  </Button>
                                </Upload>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="mb-0 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-submit"
                          disabled={loading}
                        >
                          {loading ? <Spin size="small" /> : "Save Changes"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <div style={{ position: "relative" }}>
          <CloseOutlined
            onClick={handleCloseModal}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              fontSize: "16px",
              cursor: "pointer",
              zIndex: 1,
              color: "red",
            }}
          />
          <Modal.Body style={{ padding: 0, margin: 0 }}>
            {(selectedImage || empData?.profile_image_url) && (
              <img
                src={imagePreview || selectedImage || (empData?.profile_image_url ? `${base_path_img}${empData.profile_image_url}` : "/placeholder.svg")}
                alt="Full Size Preview"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};

export default GeneralSettings;
